import { Button } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import BaseListPage from "../../../base/BaseListPage";
import BiomentricLogsPresenter from "./BiomentricLogsPresenter";
import CardView from "../../../components/common/CardView";
import DateRangePicker from "../../../components/common/DateRangePicker";
import { FloatingForm } from "../../../components/common/Converter";
import Progress from "../../../components/Progress";
import InputFactory from "../../../components/InputFactory";

class BiometricLogsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new BiomentricLogsPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      objects: [],
      employee: [],
      count: 0,
      limit: 50,
      current: 1,
      logMessage: { value: "", label: "" },
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const employee = await findObjectUseCase().execute("employees");
    this.setState({ employee });
  }

  setCount(count) {
    this.setState({ count });
  }

  getCollectionName() {
    return "biometric_logs";
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  onChangeFilter(type, value, field) {
    // Copy the current filters from the state
    const where = { ...this.state.filters };
    // Apply the new filter
    switch (type) {
      case "Pointer":
        if (Object.keys(value).length > 0) {
          where[field] = { id: value.id };
        } else {
          delete where[field]; // Remove filter if no value
        }
        break;
      case "Boolean":
        if (value !== null) {
          where[field] = value;
        } else {
          delete where[field]; // Remove filter if no value
        }
        break;
      case "Number":
        if (!isNaN(value)) {
          where[field] = value;
        } else {
          delete where[field]; // Remove filter if no value
        }
        break;
      default:
        if (value) {
          where[field] = value;
        } else {
          delete where[field]; // Remove filter if no value
        }
    }

    // Update the state and submit the combined filters
    this.setState({ filters: where }, () => {
      this.filterSubmit(this.state.filters);
    });
  }

  handleViewObj(object) {
    // window.open(object.faceCapture, "_blank", "noopener,noreferrer");
    this.setState({ viewModal: true, link: object.faceCapture });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, count, limit, current, loading } = this.state;
    if (!schema) return <Progress />;

    // const user = this.getCurrentUser();
    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} System Administration {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>

              <CardView style={{ borderRadius: 0 }}>
                <div className="d-flex gap-2">
                  <div className="d-flex">
                    {Object.keys(schema.filters || {}).map((field) => {
                      let { type, ...options } = schema.filters[field];
                      return (
                        <InputFactory
                          key={field}
                          className="ms-1"
                          type={type}
                          field={field}
                          where={{}}
                          onChange={this.onChangeFilter.bind(this, type)}
                          {...options}
                        />
                      );
                    })}
                  </div>
                  <div>
                    <InputFactory
                      type="Pointer"
                      target="employees"
                      keys={[
                        "Firstname",
                        "Middlename",
                        "surname",
                        "biometricId",
                      ]}
                      placeholder="Employee"
                      onChange={(value) => {
                        console.log("VAL: ", value.biometricId);
                        this.onChangeFilter(
                          "String",
                          value.biometricId ? String(value.biometricId) : "",
                          "pin",
                        );
                      }}
                    />
                  </div>
                  <div>
                    <DateRangePicker
                      fields={["createdAt", "updatedAt", ""]}
                      onFilter={(filterObj) => {
                        try {
                          const startRaw = filterObj?.createdAt?.$gte; // "YYYY-MM-DD"
                          const endRaw = filterObj?.updatedAt?.$lte || startRaw;

                          if (!startRaw) {
                            this.searchSubmit({});
                            this.setState({ filters: {} });
                            return;
                          }

                          // ✅ send ONLY fields that backend recognizes
                          const filter = {
                            timestamp: {
                              $gte: `${startRaw}T00:00:00.000Z`,
                              $lte: `${endRaw}T23:59:59.999Z`,
                            }, // keep as string (or Date if your system supports)
                          };

                          this.searchSubmit(filter);
                          this.setState({ filters: filter });
                        } catch (e) {
                          this.searchSubmit({});
                          this.setState({ filters: {} });
                        }
                      }}
                    />
                  </div>
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center">
                    <h4 className="text-primary">{schema.label}</h4>
                  </div>
                </CardView>
              </div>

              <Table
                progress={loading}
                fields={schema.fields}
                objectData={this.handleViewObj.bind(this)}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                // actionsList={[
                //   {
                //     label: <i className="bi bi-search">View</i>,
                //     actionType: "object",
                //   },
                // ]}
                loadPagination={this.onClickPagination.bind(this)}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id"],
                )}
                // onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>

        {this.state.viewModal && (
          <FloatingForm width="20rem">
            <CardView style={{ padding: 0 }}>
              <div className="d-grid">
                {/* <div className="row"> */}
                <img width="100%" src={this.state.link} alt="biometric" />
                {/* <div className="col-lg-6 pe-5 ps-5">{printContent()}</div> */}
                {/* </div> */}
                <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3 mt-3">
                  <Button
                    className="btn btn-primary"
                    onClick={() => {
                      this.setState({ viewModal: false });
                    }}
                  >
                    Ok
                  </Button>
                </div>
              </div>
            </CardView>
          </FloatingForm>
        )}
      </>
    );
  }
}

export default withRouter(BiometricLogsPage);
